import React, { Component } from 'react';
import Modal from "react-responsive-modal";
import {Link} from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router-dom";

import { getlanguagelist } from "../../helpers/changelanguage";
import Profile from "../FeedContainer/Profile";
import AddboxRight from "../FeedContainer/AddboxRight";
import PollingDetails from "./detail";
import './polling.css';


class Polling extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userImage     : '',
            userPercentage: 0,
            totalFriend   : 0,
            totalPost     : 0,
            urlFeedId     : this.props.urlFeedId,
            membership    : 'BASIC'
        };
     }

    componentDidMount(){
        this.setState({
            userImage         : this.props.currentUserDetails.user.image,
            membership        : this.props.currentUserDetails.user.membership,
            userPercentage    : (Object.keys(this.props.listOfFeed.listfeed).length > 0) ? this.props.listOfFeed.listfeed.current_user.profile_completion_percentage : 0,
            tototalFriend     : (Object.keys(this.props.listOfFeed.listfeed).length > 0) ? this.props.listOfFeed.listfeed.current_user.total_friend : 0,
            totalPost         : (Object.keys(this.props.listOfFeed.listfeed).length > 0) ? this.props.listOfFeed.listfeed.current_user.total_post : 0
    
        })
    }
   
    UNSAFE_componentWillReceiveProps(nextProps,prevProps){
        
       
    }
    
    render() {
       
        return (
            <div className="container">
              <div className="clr25"></div>
              <div className="content_area">
                <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 left_area">
                    <Profile profile_percentage={this.state.userPercentage} profile_image={this.state.userImage} total_post={this.state.totalPost} total_friend={this.state.tototalFriend} membership={this.state.membership}/>
                </div>
                <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 right_area">
                    {(this.props.currentUserDetails.membership != "GOLD") ?
                        <AddboxRight />
                        : null 
                    }
                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 post_area">
                   <div className="row">
                     <PollingDetails  urlFeedId={this.props.urlFeedId} currentUserDetails={this.props.currentUserDetails}/>
                    </div>
                </div>
              </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        listOfFeed         : state.listfeed,
        currentUserDetails : state.login, 
    }
}

const mapDispatchToProps = dispatch => {
    return {
     // getChatlist      : bindActionCreators(getChatlist, dispatch),
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Polling));
